import { FC, useMemo, useRef, useState } from 'react';
import { ScrollView, TouchableOpacity, View } from 'react-native';
import { SportScreenProps } from './types';
import { sportStyled as styled } from './styled';
import { STYLE_VARS } from '../../constants/style-vars';
import { Image } from '../../components/Image';
import { Text } from '../../components/Text';
import { TextInput } from '../../components/TextInput/TextInput';
import { Button } from '../../components/Button';
import SportFacilityBooking from './components/SportFacilityBooking';
import { Footer } from '../../components/Footer';
import SportCoaching from './components/SportCoaching';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import SportsLayout from './components/SportsLayout';
import { FONTS } from '../../constants';
import { NavigationService } from '../../services/navigation';

const Sports: FC<SportScreenProps> = ({ navigation, route }) => {
  const isDesktop = useIsDesktop();
  const screen = route.params.screen;
  // const [screen, setScreen] = useState<typeof route.params.screen>(
  //   route.params.screen
  // );
  const scrollViewRef = useRef<ScrollView>(null);

  const renderContent = useMemo(() => {
    if (screen === 'Facility') {
      return (
        <SportFacilityBooking
          onPressCoaching={() => {
            // setScreen('Coaching');
            navigation.setParams({ screen: 'Coaching' });
            if (scrollViewRef.current) {
              scrollViewRef.current.scrollTo({ y: 0, animated: true });
            }
          }}
        />
      );
    } else {
      return <SportCoaching />;
    }
  }, [screen, navigation]);
  if (isDesktop()) {
    return (
      <SportsLayout
        current={screen}
        navigate={navigation}
        title={screen === 'Coaching' ? 'Sports coaching' : 'Facility booking'}
      >
        {renderContent}
      </SportsLayout>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false} ref={scrollViewRef}>
      <View style={styled.headerWrapper}>
        <View
          style={{
            paddingVertical: 20,
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <TouchableOpacity
              style={{
                padding: 5,
                paddingRight: 20,
              }}
              onPress={() => {
                NavigationService.pop();
              }}
            >
              <Image
                source={require('../../assets/left-arrow.png')}
                style={{
                  height: 14,
                  width: 10,
                  resizeMode: 'contain',
                  tintColor: STYLE_VARS.primaryColor,
                }}
              />
            </TouchableOpacity>
            <Image
              source={require('../../assets/book-sports-facility.png')}
              style={{
                width: 24,
                height: 24,
                resizeMode: 'contain',
                marginRight: 10,
              }}
            />
            <Text
              style={{
                fontSize: 20,
                letterSpacing: 1,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                color: STYLE_VARS.textColor,
                fontWeight: '500',
              }}
            >
              SPORTS
            </Text>
          </View>
          <View
            style={{
              width: '40%',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          ></View>
        </View>
      </View>
      <View style={styled.headerWrapper}>
        <View
          style={{
            paddingVertical: 20,
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: 20,
          }}
        >
          <Button
            text="FACILITY BOOKING"
            className={screen === 'Facility' ? 'green-button' : ''}
            style={
              screen === 'Facility'
                ? STYLE_VARS.fullWGreenButton
                : STYLE_VARS.unActiveButton
            }
            arrowStyle={
              screen !== 'Facility' && { tintColor: STYLE_VARS.primaryColor }
            }
            textStyle={{
              color: screen === 'Facility' ? 'white' : STYLE_VARS.textColor,
            }}
            onPress={() => {
              // setScreen('Facility');
              navigation.setParams({ screen: 'Facility' });
            }}
          />
          <Button
            text="SPORTS COACHING"
            className={screen === 'Coaching' ? 'green-button' : ''}
            arrowStyle={
              screen !== 'Coaching' && { tintColor: STYLE_VARS.primaryColor }
            }
            style={
              screen === 'Coaching'
                ? STYLE_VARS.fullWGreenButton
                : STYLE_VARS.unActiveButton
            }
            textStyle={{
              color: screen === 'Coaching' ? 'white' : STYLE_VARS.textColor,
            }}
            onPress={() => {
              // setScreen('Coaching');
              navigation.setParams({ screen: 'Coaching' });
            }}
          />
        </View>
      </View>
      <View>{renderContent}</View>
      <Footer />
    </ScrollView>
  );
};

export default Sports;
